import { Box } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { FC } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { CommentParentTableType, type SalesPipeline } from "@/graphql/codegen/graphql"

interface SalesOpportunityExpandedRowProps {
  row: Row<SalesPipeline>
}

export const SalesOpportunityExpandedRow: FC<SalesOpportunityExpandedRowProps> = ({ row }) => (
  <Box className='flex gap-6 p-4' data-testid={`sales-opportunity.expanded-row-${row.original.id}`}>
    <Box className='min-w-0 flex-1' data-testid={`sales-opportunity.expanded-row.comments-section-${row.original.id}`}>
      <CommentsSection referenceId={row.original.id} type={CommentParentTableType.SalesPipeline} />
    </Box>
  </Box>
)
